// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__OYkG6","large":"styles_large__-Hy8e"};